import { css } from "lit";

export const changeEmailModalStyle = css`
  .form-actions {
    margin-top: var(--sds-size-space-400);
  }
`;
